import './Deck.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import ButtonCloseMainPopup from "../ButtonCloseMainPopup";
import React from "react";
import {isMobile} from 'react-device-detect';
import DeckSlider from "./DeckSlider";
import LibSlider from "./LibSlider";

function DeckComponent() {

    const {user} = useTypedSelector(state => state.auth);

    let MobileClasses = '';
    if (isMobile) {
        MobileClasses = ' deck-editor-zoom'
    }

    return (
        <div className={"deck-editor-container main-popup-container" + MobileClasses}>

            <ButtonCloseMainPopup/>

            <div className="lib-count">
                <div className='lib-count-text'>Library: {user.library.total_amount}</div>
            </div>


            <LibSlider />

            <div className='deckYellowLine'></div>

            <div className="lib-count deck-count">
                <div className='lib-count-text'>Deck: {user.deck.total_amount}</div>
            </div>
             <DeckSlider />
        </div>
    );
}

export default DeckComponent;
